<script setup>
import { useProviderHomeStore } from '@/stores/home-providers';

const providerStore = useProviderHomeStore();

onMounted(async () => {
  if (providerStore.state.providers.length === 0) {
    await providerStore.fetchProviders();
  }
});
</script>

<template>
  <BaseCarousel
    title="Provedores"
    button-label="Ver todos"
    button-link="/providers"
    :is-loading="providerStore.state.isLoading"
  >
    <template v-slot:default="slotProps">
      <ProviderCard
        v-if="slotProps.isLoading"
        shimmer
        v-for="index in 11"
        :key="index"
      />
      <ProviderCard
        v-if="!slotProps.isLoading"
        v-for="provider in providerStore.state.providers"
        :key="provider.id"
        :data="provider"
      />
    </template>
  </BaseCarousel>
</template>
